const { AxiosAdapter } = require("../http/http-adapter");
const { validatePaymentIntentSchema } = require("../validator");

class PaymentIntent {
    constructor({ accessToken, baseUrl }) {
        this.accessToken = accessToken
        this.baseUrl = baseUrl;
        this.request = new AxiosAdapter(this.baseUrl);
        this.request.setAuthHeader(this.accessToken);
    }

    create({ paymentIntent }) {
        return new Promise((resolve, reject) => {
            const paymentIntentSchemaIsValid = validatePaymentIntentSchema(paymentIntent);
            if (paymentIntentSchemaIsValid instanceof Error) throw new Error("Payment intent is not valid.");
            this.request
                .post('/payment-intent', paymentIntent)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    updateStatus({ gatewayPaymentIntentId, status}) {
        return new Promise((resolve, reject) => {
            this.request
                .patch(`/payment-intent/${gatewayPaymentIntentId}`, { status })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

module.exports = {
  PaymentIntent,
};
